@if (radioLabels && radioForm) {
  <div class="specialist-categorization-selection-container">
    <app-info-box
      title="{{ 'steps.specialistCategorizationSelection.type_consultation' | translate }}"
      description="{{ 'steps.specialistCategorizationSelection.select_specialty' | translate }}"
    ></app-info-box>
    <div class="container-radio-elements" [formGroup]="radioForm">
      <nz-radio-group [formControlName]="'specialistType'">
        <div class="radio-element-list">
          @for (radioButton of radioLabels; track radioButton.id; let idx = $index) {
            <label nz-radio [nzValue]="radioButton">{{ radioButton.description | translate }}</label>
          }
        </div>
      </nz-radio-group>
    </div>
  </div>
}
